import React from 'react';

const TitleInput = ({ text, required = false, className = '', children = <></> }) => {
  return (
    <p className={`text-black/85 mt-4 mb-2 flex items-center ${className}`}>
      {required && (
        <span className="text-danger-411 mr-1">
          <img src={require('assets/resources/Required.svg').default} alt="required" width={7} height={7} />
        </span>
      )}
      {text}
      {children}
    </p>
  );
};

export default React.memo(TitleInput);
